import PracticeAddresses from './PracticeAddresses'

export default PracticeAddresses
